module.exports = __webpack_public_path__ + "img/image.487c4fba.png";